import { render } from "./IntroductionButton.vue?vue&type=template&id=04800357&scoped=true"
import script from "./IntroductionButton.vue?vue&type=script&lang=js"
export * from "./IntroductionButton.vue?vue&type=script&lang=js"

import "./IntroductionButton.vue?vue&type=style&index=0&id=04800357&scoped=true&lang=stylus"

import exportComponent from "D:\\project\\xampp\\htdocs\\ui\\2025\\07\\tokyo-shoseki\\r9\\08w_w2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04800357"]])

export default __exports__